<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export const inputVariants = cva(
  [
    'flex w-full min-w-0 rounded-lg bg-white',
    'border-0 ring-1 ring-inset ring-neutral-600',
    'text-primal font-display',
    'placeholder:text-placeholder',
    'outline-0 transition-colors',
    'focus:ring-inset focus:ring-2 focus:ring-primary-500',
    '[&:not(:focus):not(:read-only):hover]:bg-neutral-600/10',
    'read-only:bg-neutral-600/30 read-only:ring-neutral-600/60 read-only:text-gray-600',
    'disabled:cursor-not-allowed disabled:bg-neutral-600/30 disabled:ring-0 disabled:text-neutral-900/30',
  ].join(' '),
  {
    variants: {
      size: {
        xs: 'h-6 px-2 text-xs',
        sm: 'h-8 px-2 text-xs',
        md: 'h-10 px-2 text-base',
        lg: 'h-[52px] px-3 text-base',
        xl: 'h-[60px] px-4 text-lg',
      },
      error: {
        true: 'ring-error!',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type InputVariants = VariantProps<typeof inputVariants>

export interface InputProps {
  class?: HTMLAttributes['class']
  size?: InputVariants['size']
  error?: boolean | string
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(defineProps<InputProps>(), {
  size: 'md',
})

const modelValue = defineModel<string | number | null>()
</script>

<template>
  <input
    v-model="modelValue"
    :aria-invalid="!!props.error"
    :class="cn(inputVariants({ size: props.size, error: !!props.error }), props.class)"
  />
</template>
